import { useLanguage } from "@/lib/i18n/LanguageContext";
import type { SigningTab } from "../useSigningPageState";

interface SigningEmptyStateProps {
  tab: SigningTab;
  /** A search term or filter is hiding rows, rather than there being none. */
  isFiltered: boolean;
}

export function SigningEmptyState({ tab, isFiltered }: SigningEmptyStateProps) {
  const { t } = useLanguage();
  const copy = pickCopy(t.signing.empty, tab, isFiltered);

  return (
    <div className="flex h-64 flex-col items-center justify-center gap-1 text-center">
      <h2 className="text-lg font-semibold">{copy.title}</h2>
      <p className="max-w-md text-sm text-muted-foreground">{copy.subtitle}</p>
    </div>
  );
}

type EmptyCopy = { title: string; subtitle: string };

function pickCopy(
  copy: { all: EmptyCopy; mine: EmptyCopy; filtered: EmptyCopy },
  tab: SigningTab,
  isFiltered: boolean
): EmptyCopy {
  if (isFiltered) return copy.filtered;
  return tab === "mine" ? copy.mine : copy.all;
}
